export const ALL_WIDGETS = [
  { component: 'FocusOfDay', label: 'Focus of the day', description: 'A daily focus note employees can set for themselves.' },
  { component: 'ToDoList', label: 'To-Do List', description: 'A personal task list for each team member.' },
  { component: 'Weather', label: 'Clock & Weather', description: 'Live clock and local weather conditions.' },
  { component: 'Quotes', label: 'Quotes', description: 'Inspirational quotes shown on the dashboard.' },
  { component: 'Links', label: 'Links', description: 'Quick-access links widget (includes your default links).' },
  { component: 'SponsorOfDay', label: 'Sponsor of the day', description: 'Highlights a sponsor or partner on the dashboard.' },
];
